export default "__VITE_ASSET__CUhQz0Je__"